import { createSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import { initialState } from './reducer';

/**
 * Direct selector to the members state domain
 */

const selectMembersDomain = (state: ApplicationRootState) => {
  return state || initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by Members
 */

const makeSelectMembers = () =>
  createSelector(
    selectMembersDomain,
    substate => {
      return substate;
    },
  );

export default makeSelectMembers;
export { selectMembersDomain };
